/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable */
import { Euler, Shape, Vector3 } from 'three';
import { generateUUID } from 'three/src/math/MathUtils';
import * as THREE from 'three';
import { Granit } from 'src/services/granits';
import { BucketsUrls } from 'src/services/file';
import { getBoxOfPlating } from './plating.utils';

export const isVectorNul = (vector: Vector3) => {
  if (vector.x === 0 && vector.y === 0 && vector.z === 0) return true;
  return false;
};

const aroundNumber = (numberToRound: number) => {
  return parseFloat(numberToRound.toFixed(5));
};

export const getWidthMonument = (pieces: any[], customPlatings: any[]) => {
  let backLeft: Vector3 | undefined = undefined;
  let backRight: Vector3 | undefined = undefined;
  let frontLeft: Vector3 | undefined = undefined;
  let frontRight: Vector3 | undefined = undefined;

  let minY: number | undefined = undefined;

  pieces.forEach((element) => {
    const elementGeometry = element.geometry.attributes['position'].array;
    for (let i = 0; i < elementGeometry.length; i += 3) {
      if (minY === undefined || minY > aroundNumber(elementGeometry[i + 1] + element.position.y)) {
        minY = aroundNumber(elementGeometry[i + 1] + element.position.y);
      }
    }
  });

  pieces.forEach((element) => {
    const elementGeometry = element.geometry.attributes['position'].array;
    for (let i = 0; i < elementGeometry.length; i += 3) {
      const elementX = aroundNumber(elementGeometry[i + 0] + element.position.x);
      const elementY = aroundNumber(elementGeometry[i + 1] + element.position.y);
      const elementZ = aroundNumber(elementGeometry[i + 2] + element.position.z);

      if (elementY === minY) {
        if (backLeft === undefined) backLeft = new Vector3(elementX, elementY, elementZ);
        if (backRight === undefined) backRight = new Vector3(elementX, elementY, elementZ);
        if (frontLeft === undefined) frontLeft = new Vector3(elementX, elementY, elementZ);
        if (frontRight === undefined) frontRight = new Vector3(elementX, elementY, elementZ);

        if (elementX < backLeft.x) backLeft = new Vector3(elementX, minY, backLeft.z);
        if (elementX < frontLeft.x) frontLeft = new Vector3(elementX, minY, frontLeft.z);
        if (elementX > backRight.x) backRight = new Vector3(elementX, minY, backRight.z);
        if (elementX > frontRight.x) frontRight = new Vector3(elementX, minY, frontRight.z);

        if (elementZ < backLeft.z) backLeft = new Vector3(backLeft.x, minY, elementZ);
        if (elementZ > frontLeft.z) frontLeft = new Vector3(frontLeft.x, minY, elementZ);
        if (elementZ < backRight.z) backRight = new Vector3(backRight.x, minY, elementZ);
        if (elementZ > frontRight.z) frontRight = new Vector3(frontRight.x, minY, elementZ);
      }
    }
  });

  // for (const el of customPlatings) {
  //   if (el.shape) {
  //     const { box } = getBoxOfPlating(el);

  //     if (!minY || box.min.y < minY) {
  //       minY = box.min.y;
  //     }
  //   }
  // }

  // for (const el of customPlatings) {
  //   if (el.shape) {
  //     const { geometry } = getBoxOfPlating(el);

  //     for (let i = 0; i < geometry.length; i += 3) {
  //       const elementX = aroundNumber(geometry[i + 0]);
  //       const elementY = aroundNumber(geometry[i + 1]);
  //       const elementZ = aroundNumber(geometry[i + 2]);

  //       if (parseFloat(elementY.toFixed(2)) === parseFloat((minY ?? 0).toFixed(2))) {
  //         if (backLeft === undefined) backLeft = new Vector3(elementX, elementY, elementZ);
  //         if (backRight === undefined) backRight = new Vector3(elementX, elementY, elementZ);
  //         if (frontLeft === undefined) frontLeft = new Vector3(elementX, elementY, elementZ);
  //         if (frontRight === undefined) frontRight = new Vector3(elementX, elementY, elementZ);

  //         if (elementX < backLeft.x) backLeft = new Vector3(elementX, minY, backLeft.z);
  //         if (elementX < frontLeft.x) frontLeft = new Vector3(elementX, minY, frontLeft.z);
  //         if (elementX > backRight.x) backRight = new Vector3(elementX, minY, backRight.z);
  //         if (elementX > frontRight.x) frontRight = new Vector3(elementX, minY, frontRight.z);

  //         if (elementZ < backLeft.z) backLeft = new Vector3(backLeft.x, minY, elementZ);
  //         if (elementZ > frontLeft.z) frontLeft = new Vector3(frontLeft.x, minY, elementZ);
  //         if (elementZ < backRight.z) backRight = new Vector3(backRight.x, minY, elementZ);
  //         if (elementZ > frontRight.z) frontRight = new Vector3(frontRight.x, minY, elementZ);
  //       }
  //     }
  //   }
  // }

  return {
    backLeft: backLeft ?? new Vector3(0, 0, 0),
    backRight: backRight ?? new Vector3(0, 0, 0),
    frontLeft: frontLeft ?? new Vector3(0, 0, 0),
    frontRight: frontRight ?? new Vector3(0, 0, 0),
  };
};

export const getLengthWithKey = (
  mode: 'closoir' | 'double closoir' | 'tete',
  key: 'front' | 'back' | 'left' | 'right',
  depth: { front: number; back: number; left: number; right: number },
  length: number,
) => {
  switch (mode) {
    case 'closoir': {
      if (key === 'front') return length;
      if (key === 'left' || key === 'right') return length - depth.front;
      if (key === 'back') return length - depth.right - depth.left;
      break;
    }
    case 'tete': {
      if (key === 'front' || key === 'back') return length;
      if (key === 'left' || key === 'right') return length - depth.front - depth.back;
      break;
    }
    case 'double closoir': {
      if (key === 'front' || key === 'back') return length - depth.right - depth.left;
      if (key === 'left' || key === 'right') return length;
      break;
    }
  }
  return 0;
};

export const getPositionWithIndex = (
  key: 'front' | 'back' | 'left' | 'right',
  depth: { front: number; back: number; left: number; right: number },
  pieces: any[],
  customPlatings: any[],
  customPlatingsIsActive: { [key: string]: boolean },
  length: number,
  width: number,
  deltaCenterZ: number,
  mode: 'closoir' | 'double closoir' | 'tete',
) => {
  const box = getWidthMonument(pieces, customPlatings);
  const deltaX = box.backRight.x - box.backLeft.x - width;
  const deltaZ = mode === 'closoir' ? depth.front / 2 : 0;

  if (box) {
    if (key === 'front') {
      let x = box.frontLeft.x + width / 2 + deltaX / 2;
      let y = box.frontLeft.y;
      let z = box.backLeft.z + length - depth.front - deltaCenterZ;
      // if (!customPlatingsIsActive['right'] && mode === 'double closoir') x = x + depth.left / 2;
      // if (!customPlatingsIsActive['left'] && mode === 'double closoir') x = x - depth.right / 2;
      return new Vector3(x, y, z);
    }
    if (key === 'back') {
      let x = box.backLeft.x + width / 2 + deltaX / 2;
      let y = box.backLeft.y;
      let z = box.backLeft.z - deltaCenterZ;

      // if (!customPlatingsIsActive['right'] && mode !== 'tete') x = x + depth.left / 2;
      // if (!customPlatingsIsActive['left'] && mode !== 'tete') x = x - depth.right / 2;
      return new Vector3(x, y, z);
    }
    if (key === 'left') {
      let x = box.backLeft.x + deltaX / 2;
      let y = box.frontLeft.y;
      let z = box.backLeft.z + length / 2 - deltaZ - deltaCenterZ;
      // if (!customPlatingsIsActive['front'] && mode !== 'double closoir') z = z + depth.back / 2;
      // if (!customPlatingsIsActive['back'] && mode === 'tete') z = z - depth.front / 2;

      if (
        depth.front !== depth.back &&
        mode === 'tete' &&
        customPlatingsIsActive['front'] &&
        customPlatingsIsActive['back']
      ) {
        z += (depth.back - depth.front) / 2;
      }

      return new Vector3(x, y, z);
    }
    if (key === 'right') {
      let x = box.backLeft.x + width - depth.right + deltaX / 2;
      let y = box.frontRight.y;
      let z = box.backRight.z + length / 2 - deltaZ - deltaCenterZ;

      // if (!customPlatingsIsActive['front'] && mode !== 'double closoir') z = z + depth.back / 2;
      // if (!customPlatingsIsActive['back'] && mode === 'tete') z = z - depth.front / 2;

      if (
        depth.front !== depth.back &&
        mode === 'tete' &&
        customPlatingsIsActive['front'] &&
        customPlatingsIsActive['back']
      ) {
        z += (depth.back - depth.front) / 2;
      }
      return new Vector3(x, y, z);
    }
  }
};

export const changeSoleShape = (shape: Shape, length: number, height: number) => {
  shape.moveTo(-length / 2, 0);
  shape.lineTo(length / 2, 0);
  shape.lineTo(length / 2, -height);
  shape.lineTo(-length / 2, -height);
};

export const createSoles = (
  pieces: any[],
  customPlatings: any[],
  customSoles: any[],
  setCustomSoles: (customSoles: any[]) => void,
  customSize?: {
    length?: number;
    width?: number;
    height?: number;
    holeWidth?: number;
    holeLength?: number;
    poseX?: number;
    poseZ?: number;
    frontDepth?: number;
    hasCustomFrontDepth?: boolean;
    orientation?: 'x' | 'z';
    holeMode?: 'dimension' | 'pose';
    mode?: 'closoir' | 'double closoir' | 'tete';
  },
  checkMinMax?: (length: number) => void,
) => {
  const mode = customSize?.mode ?? 'closoir';
  let soles: any[] = [];

  const solesInformations = [
    {
      key: 'front',
      label: 'Devant',
      isRotated: false,
    },
    {
      key: 'back',
      label: 'Derière',
      isRotated: false,
    },
    {
      key: 'left',
      label: 'Gauche',
      isRotated: true,
    },
    {
      key: 'right',
      label: 'Droite',
      isRotated: true,
    },
  ];

  const monumentBox = getWidthMonument(pieces, customPlatings);

  let poseX = customSize?.poseX ?? 0.05;
  let poseZ = customSize?.poseZ ?? 0.05;

  let height = 0.05;
  let monumentWidth = 1.4;
  let monumentLength = 2.4;

  let holeWidth = 0.9;
  let holeLength = 1.9;

  let pieceAboveLenth = monumentBox.frontRight.z - monumentBox.backRight.z;
  let pieceAboveWidth = monumentBox.frontRight.x - monumentBox.frontLeft.x;

  if (pieces.length > 0) {
    monumentWidth = pieceAboveWidth + 0.4;
    monumentLength = pieceAboveLenth + 0.4;

    if (customSize?.holeMode === 'pose') {
      holeWidth = pieceAboveWidth - poseX * 2;
      holeLength = pieceAboveLenth - poseZ * 2;
    } else {
      holeWidth = pieceAboveWidth;
      holeLength = pieceAboveLenth;
    }
  }

  if (customSize?.holeMode === 'dimension') {
    if (customSize?.holeLength !== undefined) holeLength = customSize.holeLength;
    if (customSize?.holeWidth !== undefined) holeWidth = customSize.holeWidth;
    poseX = Math.max(0, (pieceAboveWidth - holeWidth) / 2);
    poseZ = Math.max(0, (pieceAboveLenth - holeLength) / 2);
  } else {
    if (customSize?.poseX !== undefined) poseX = customSize.poseX;
    if (customSize?.poseZ !== undefined) poseZ = customSize.poseZ;
  }

  if (customSize) {
    if (customSize.length !== undefined) monumentLength = customSize.length;
    if (customSize.width !== undefined) monumentWidth = customSize.width;
    if (customSize.height !== undefined) height = customSize.height;
  }
  const minDepth = 0.07;

  let frontDepth = 0;

  if (customSize?.hasCustomFrontDepth) {
    frontDepth = customSize.frontDepth ?? 0;
    if (frontDepth < minDepth) {
      frontDepth = minDepth;
    } else if (frontDepth + holeLength + minDepth > monumentLength) {
      frontDepth = monumentLength - holeLength - minDepth;
    }
  } else {
    frontDepth = (monumentLength - holeLength) / 2;
  }

  let backDepth = monumentLength - holeLength - frontDepth;
  let leftDepth = (monumentWidth - holeWidth) / 2;
  let rightDepth = (monumentWidth - holeWidth) / 2;

  if (frontDepth < minDepth) {
    frontDepth = minDepth;
    holeLength = monumentLength - frontDepth * 2;
  }
  if (backDepth < minDepth) {
    backDepth = minDepth;
    holeLength = monumentLength - backDepth * 2;
  }
  if (leftDepth < minDepth) {
    leftDepth = minDepth;
    holeWidth = monumentWidth - leftDepth * 2;
  }
  if (rightDepth < minDepth) {
    rightDepth = minDepth;
    holeWidth = monumentWidth - rightDepth * 2;
  }

  solesInformations.forEach((el, elIndex) => {
    let customSolesIsActive: { [key: string]: boolean } = {};

    customSoles.forEach((element) => {
      customSolesIsActive[element.key] = element.isActive;
    });

    const shape = new Shape();
    const length = getLengthWithKey(
      mode,
      el.key as 'front' | 'back' | 'left' | 'right',
      {
        // front: customSolesIsActive['front'] ? frontDepth : 0,
        // back: customSolesIsActive['back'] ? backDepth : 0,
        // left: customSolesIsActive['left'] ? leftDepth : 0,
        // right: customSolesIsActive['right'] ? rightDepth : 0,

        front: frontDepth,
        back: backDepth,
        left: leftDepth,
        right: rightDepth,
      },
      el.key === 'front' || el.key === 'back' ? monumentWidth : monumentLength,
    );

    checkMinMax?.(length);

    let pieceDepth = 0;

    switch (el.key) {
      case 'front':
        pieceDepth = frontDepth;
        break;
      case 'back':
        pieceDepth = backDepth;
        break;
      case 'left':
        pieceDepth = leftDepth;
        break;
      case 'right':
        pieceDepth = rightDepth;
        break;
    }

    let shapeDetails = {
      display: true,
      hasSlope: false,
      isRotated: el.isRotated,
      length: length,
      height,
      monumentWidth,
      monumentLength,
      holeWidth,
      holeLength,
      poseX,
      poseZ,
      frontDepth,
      depth: pieceDepth,
      holeMode: customSize?.holeMode,
      mode,
      orientation: customSize?.orientation,
      hasCustomFrontDepth: customSize?.hasCustomFrontDepth,
    };

    changeSoleShape(shape, length, shapeDetails.height);

    const deltaCenterZ =
      customSize?.holeMode === 'pose'
        ? backDepth - poseZ
        : backDepth - (pieceAboveLenth - holeLength) / 2;
    soles.push({
      texture: customSoles[elIndex]?.texture,
      granit: customSoles[elIndex]?.granit,
      id: generateUUID(),
      key: el.key,
      shape,
      shapeDetails,
      isActive: customSoles[elIndex] ? customSoles[elIndex].isActive : true,
      position: getPositionWithIndex(
        el.key as 'front' | 'back' | 'left' | 'right',
        {
          front: frontDepth,
          back: backDepth,
          left: leftDepth,
          right: rightDepth,
        },
        pieces,
        customPlatings,
        customSolesIsActive,
        monumentLength,
        monumentWidth,
        deltaCenterZ,
        mode,
      ),
      extrudeSettings: {
        curveSegments: 12,
        steps: 2,
        depth: pieceDepth,
        bevelEnabled: false,
      },
    });
  });

  setCustomSoles(soles);
};

export const isSoleUse = (customSoles: any[], key: 'front' | 'back' | 'left' | 'right') => {
  const sole = customSoles.find((el) => el.key === key);

  if (!sole) return false;
  return sole.isActive;
};

export const changeSoleStatus = (
  key: 'front' | 'back' | 'left' | 'right',
  customSoles: any[],
  setCustomSoles: (customSoles: any[]) => void,
) => {
  const mapedCustomSoles = customSoles.map((el) => {
    if (el.key === key) {
      return {
        ...el,
        isActive: !el.isActive,
      };
    }
    return el;
  });

  setCustomSoles(mapedCustomSoles);
};

export const getBoxOfSole = (sole: any) => {
  const box1GeometryThree = new THREE.ExtrudeGeometry(sole.shape, sole.extrudeSettings);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const box1Geometry: number[] = box1GeometryThree.attributes.position.array;
  const box1Postion = sole.position;
  const box1Rotation = new Euler(0, sole.shapeDetails.isRotated ? 1.57 : 0, 0, 'XYZ');

  const rotationMatrix = new THREE.Matrix4();
  rotationMatrix.makeRotationFromEuler(box1Rotation);

  const translationMatrix = new THREE.Matrix4();
  translationMatrix.makeTranslation(box1Postion.x, box1Postion.y, box1Postion.z);

  const geometryWithoutPosition = box1Geometry.slice();
  for (let i = 0; i < geometryWithoutPosition.length; i += 3) {
    const vertex = new THREE.Vector3(
      geometryWithoutPosition[i],
      geometryWithoutPosition[i + 1],
      geometryWithoutPosition[i + 2],
    );

    vertex.applyMatrix4(rotationMatrix);

    geometryWithoutPosition[i] = vertex.x;
    geometryWithoutPosition[i + 1] = vertex.y;
    geometryWithoutPosition[i + 2] = vertex.z;
  }
  const transformedGeometry = box1Geometry.slice();
  for (let i = 0; i < transformedGeometry.length; i += 3) {
    const vertex = new THREE.Vector3(
      transformedGeometry[i],
      transformedGeometry[i + 1],
      transformedGeometry[i + 2],
    );

    vertex.applyMatrix4(rotationMatrix);
    vertex.applyMatrix4(translationMatrix);

    transformedGeometry[i] = vertex.x;
    transformedGeometry[i + 1] = vertex.y;
    transformedGeometry[i + 2] = vertex.z;
  }

  const box = new THREE.Box3();
  box.setFromArray(transformedGeometry);

  return { box: box, geometry: transformedGeometry, geometryWithoutPosition };
};
